import AccountingComponent from "../../components/AccountingComponent";
import { connect } from "react-redux";
import swal from 'sweetalert2';
import i18n from "i18next";

import {
  accountingRequestConfirm,
  accountingRequestCancel,
  getAccountingRequests,
  confirmAllCost,
  setFilter
} from "../actions/accountant";

var mapStateToProps = (state, ownProps) => {
  return {
    employees: state.employees.employeeList.employeeListAccountingApproval,
    isManager: state.login.employeeInfo.isManager,
    requestsList: state.managers.data,
    accountingRequestList: state.accounting.allData,
    accessToken: state.login.employeeInfo.accessToken,
    filter: state.accounting.filter,
    userID: state.login.employeeInfo.uid,
    curentExchangeRate: state.exchangeRate.curentExchangeRate,
    isLoading: state.loading.isLoading
  }
}
var mapDispatchToProps = (dispatch) => {
  return {
    accountingRequestConfirmAction: (costData, accessToken, cb) => {
      dispatch(accountingRequestConfirm({
        'costData': costData,
        'accessToken': accessToken
      }));
    },
    accountingRequestCancelAction: (costData, accessToken, cb) => {
      cb();
      swal({
        title: i18n.t("areYouSure"),
        text: i18n.t("costFormWillRejected"),
        type: 'warning',
        input: "textarea",
        inputPlaceholder: i18n.t("enterDescription"),
        inputValidator: function (value) {
          return new Promise((resolve, reject) => {
            if (!value)
              reject(i18n.t("doNotLeaveDescriptionEmpty"))
            else
              resolve()
          })
        },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t("yes"),
        cancelButtonText: i18n.t("cancelButton")
      }).then(function (description) {
        dispatch(accountingRequestCancel({
          'costData': costData,
          'accessToken': accessToken,
          'description': description,
        }));
      }).catch((e) => {
        console.log(e)
      });

    },
    getAccountingRequest: (accessToken, employee, month, year, cb) => {
      dispatch(getAccountingRequests({
        'accessToken': accessToken,
        'employee': employee,
        'month': month,
        'year': year,
      }));
    },
    confirmAllCostsButtonAction: (accessToken,employee, month, year) => {
      dispatch(confirmAllCost({
        'accessToken': accessToken,
        'employee': employee,
        'month': month,
        'year': year,}))
    },
    setFilter: (filterValue) => {
      dispatch(setFilter(filterValue))
    },
  }
};
const Accounting = connect(mapStateToProps, mapDispatchToProps)(AccountingComponent);
export default Accounting;
